import "./Navbar.css";
import "./ResponsiveNavbar.css";
import React from "react";
import { useEffect } from "react";
import useNavbar from "./useNavbar";
import { NavLink } from "react-router-dom";
import { getTranslatedText as translate } from "../Localization/Translation";
import logo from "./logo.jpg";
import LanguageSelection from "../LanguageSelection/LanguageSelect.js";

function Navbar() {
  const {
    clickHamburger,
    locale,
    ContactRef,
    aboutRef,
    defineRef,
    mainRef,
    joinRef,
    servicesRef,
  } = useNavbar();

  const handleChange = (to) => {
    // if (to === "define") window.scrollTo(800, 800);
    // else if (to === "services") window.scrollTo(1450, 1450);
    // else if (to === "aboutus") window.scrollTo(700, 700);
    // else if (to === "contact") window.scrollTo(2800, 2800);
    // else if (to === "join") window.scrollTo(3300, 3300);
    // else if (to === "main") window.scrollTo(0, 0);
  };
  const onContact = (e) => {
    ContactRef.current.scrollIntoView();
  };
  const onAbout = (e) => {
    aboutRef.current.scrollIntoView();
  };
  const onDefine = (e) => {
    defineRef.current.scrollIntoView();
  };
  const onMain = (e) => {
    mainRef.current.scrollIntoView();
  };
  const onJoin = (e) => {
    joinRef.current.scrollIntoView();
  };
  const onServices = (e) => {
    servicesRef.current.scrollIntoView();
  };
  return (
    <div
      className="Navbar"
      dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
      ref={mainRef}
    >
      <div className="nav-box-container">
        <div className="nav-container">
          <div className="hamburger" onClick={clickHamburger}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>

          <div className="name-lang-nav">
            {/* Switch Language */}
            <LanguageSelection />

            <div className="nav-buttons d-flex justify-content-between row">
              {/* Tabs */}

              <a
                className="btn move-to-map-btn"
                href="https://user-cleaning-service.netlify.app/"
                target="_blank"
              >
                {translate("visit-tab", locale)}
              </a>
              <NavLink
                to="/"
                className="Home-nav-tab nav-button nav-link-navbar col-1"
                onClick={onMain}
              >
                <span>{translate("main-tab", locale)}</span>
              </NavLink>
              <NavLink
                to="/"
                className="Home-nav-tab nav-button nav-link-navbar col-1"
                onClick={onServices}
              >
                <span>{translate("service-tab", locale)}</span>
              </NavLink>
              <NavLink
                to="/"
                className="Home-nav-tab nav-button nav-link-navbar col-1"
                onClick={onAbout}
              >
                <span>{translate("about-us-tab", locale)}</span>
              </NavLink>
              <NavLink
                to="/"
                className="Home-nav-tab nav-button nav-link-navbar col-1"
                onClick={onAbout}
              >
                <span>{translate("define-system", locale)}</span>
              </NavLink>
              <NavLink
                to="/"
                className="Home-nav-tab nav-button nav-link-navbar col-1"
                onClick={onContact}
              >
                <span>{translate("contactUs-header", locale)}</span>
              </NavLink>
              <NavLink
                to="/"
                className="Home-nav-tab nav-button nav-link-navbar col-1"
                onClick={onJoin}
              >
                <span>{translate("joinUs-header", locale)}</span>
              </NavLink>
            </div>
          </div>

          <div className="logo-div d-flex justify-content-between row">
            {/* Logo */}
            <div className="nav-logo" dir="auto">
              <span className="logo-text-services">
                {translate("logo-text-1", locale)}
              </span>
              <img src={logo} className="nav-logo-picture" alt="logo" />
              <span className="logo-text-saudi">
                {translate("logo-text-2", locale)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
